export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BigText.vue?vue&type=template&id=3119e0ca&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BigText.vue?vue&type=template&id=3119e0ca&scoped=true&
// module id = 239
// module chunks = 0